var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("dataScreening", {
            attrs: {
              propsData: {
                isCountry: false,
                isCurrency: false,
                adPlacement: false,
                adChannel: false
              }
            },
            on: {
              searchChange: _vm.searchChange,
              currencyChange: _vm.currencyChange
            }
          })
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticClass: "operationBut ", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.searchClick(1)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "sticky-table-header",
              rawName: "v-sticky-table-header",
              value: 0,
              expression: "0"
            },
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          ref: "tableRef",
          attrs: { id: "tableRef", data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "game", label: _vm.$t("game") }
          }),
          _c("el-table-column", {
            attrs: { prop: "platform", label: _vm.$t("platform") }
          }),
          _c("el-table-column", {
            attrs: { prop: "channel", label: _vm.$t("channel") }
          }),
          _c("el-table-column", {
            attrs: { prop: "pkg", label: _vm.$t("pkg") }
          }),
          _c("el-table-column", {
            attrs: { prop: "order_id", label: _vm.$t("orderId") }
          }),
          _c("el-table-column", { attrs: { prop: "appid", label: "appid" } }),
          _c("el-table-column", {
            attrs: { prop: "diff_details", label: _vm.$t("detailLabel") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: { color: "#409EFF", cursor: "pointer" },
                        on: {
                          click: function($event) {
                            return _vm.$refs.viewDetils.init(row.diff_details)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("view")))]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm.tableData.length
        ? _c("el-pagination", {
            staticStyle: { "text-align": "center" },
            attrs: {
              layout: "total,sizes, prev, pager, next",
              "current-page": _vm.searchData.page,
              total: _vm.total
            },
            on: {
              "size-change": _vm.sizeChange,
              "current-change": _vm.searchClick
            }
          })
        : _vm._e(),
      _c("viewDetils", { ref: "viewDetils" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }